import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => !["width", "height"].includes(prop),
})(({ width, height, theme }) => ({
  borderRadius: theme.shape.customBorderRadius[0], // 5px
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.primary.subBlue,
  borderColor: theme.palette.primary.main,
  border: `1.5px solid ${theme.palette.primary.main}`,
  width,
  height,

  "&:hover": {
    backgroundColor: theme.palette.primary.lightBlue,
    borderColor: theme.palette.primary.mainHover,
    color: theme.palette.primary.mainHover,
  },
  "&:active": {
    backgroundColor: theme.palette.primary.mainHover,
    borderColor: theme.palette.primary.mainHover,
    color: theme.palette.primary.white,
  },
  "&:disabled": {
    backgroundColor: theme.palette.primary.greyThread,
    border: `1.5px solid ${theme.palette.primary.greyThread}`,
    color: theme.palette.primary.greySecound,
    cursor: "not-allowed",
  },
}));

export const SolidRectangleLightButton = ({
  iconStart,
  iconEnd,
  width,
  height,
  children,
  ...rest
}) => {
  return (
    <StyledButton
      startIcon={iconStart}
      endIcon={iconEnd}
      width={width}
      height={height}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};
